<!-- allowSubRemapping(): {{allowSubRemapping()}}
service.allowSubRemapping(): {{service.allowSubRemapping()}} -->
<ng-template #contentTempl>
  <cms-resource-item [isRoot]="true" [content]="content()" />
</ng-template>

<div class="row mx-0" [id]="id">
  <div class="{{ hideSideBar() ? 'col-12' : 'col-lg-9 col-xxl-10' }}  order-1 order-lg-0">
    <ng-container *ngTemplateOutlet="contentTempl" />
  </div>

  <div [hidden]="hideSideBar()" class="col-lg-3 col-xxl-2 order-lg-1 order-0">
    <div class="sidebar-container sticky-top">
      <div class="d-flex flex-column gap-3">
        @if (sideBarTemplate(); as sideBarTemplate) {
          <ng-container *ngTemplateOutlet="sideBarTemplate"></ng-container>
        }
        @if (contentTree()?.length) {
          <div class="outline-cont">
            <h4 class="text-primary">
              {{ 'Outline' | appTranslate | async }}
            </h4>
            <div class="">
              <ng-template #titleTempl let-obj>
                <div class="d-flex align-items-center">
                  {{ obj.node.title }}
                  <span class="tree-item-type">{{ obj.node.type | titlecase }}</span>
                </div>
              </ng-template>
              <mat-list>
                @for (item of contentTree(); track item.id) {
                  <!-- @if (!item.meta?.hideTitle) { -->
                  <button
                    (click)="scrollIntoView(item)"
                    class="tree-item pointer w-100 mt-1 glass"
                    [ngClass]="{ active: item._inView }"
                    [matTooltip]="item.title"
                    [matTooltipShowDelay]="1000"
                    mat-button>
                    <div class="outlineItemTitle">{{ item.title }}</div>
                  </button>
                  <!-- } -->
                }
              </mat-list>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #printCont>
  <letterhead-container
    #lhc 
    [content]="contentTempl"
    [showEmailBtn]="false"
    [fileName]="content().title" />
</ng-template>

<print-case
   [isPrintMode]="true"
  [printContent]="printCont" /> -->

<modal-comp
  #disclaimerModal
  header="Confidentiality and Proprietary Information Disclaimer"
  height="auto"
  width="700px"
  [showFooter]="false">
  <ng-template modalBody>
    <div class="d-flex flex-column gap-3">
      <div>
        {{'This document contains confidential and proprietary information of EVOLUTICS Technology. By downloading this document, you acknowledge that you are bound by the terms of this disclaimer.'|appTranslate|async}}
      </div>
      <div class="fw-bold">
        {{'Restrictions on Use' | appTranslate | async}}
      </div>
      <div>
        {{'This document is provided solely for the purpose of providing a help guide on the EVOLUTICS application. Your employer is bound by confidentiality agreements on resources from this application so you may not:'|appTranslate|async}}
      </div>
      <ul class="dash-list">
        <li>{{'Share, copy, or reproduce this document in whole or in part without prior written consent from your employer.'|appTranslate|async}}</li>
        <li>{{'Use this document for any purpose other than the stated purpose.'|appTranslate|async}}</li>
        <li>{{'Disclose this document to any third party without prior written consent from your employer.'|appTranslate|async}}</li>
      </ul>
    </div>
    <div class="d-flex justify-content-end">
      <button mat-raised-button color="primary" (click)="disclaimerModal.close();_download()">
        <i class="fa fa-download" aria-hidden="true"></i>
        {{ 'I acknowledge and agree to the terms of the disclaimer.' | appTranslate | async }}
      </button>
    </div>
  </ng-template>
</modal-comp>
